import * as XLSX from 'xlsx';

export interface ExportToExcelOptions<T> {
  data: T[];
  fileName: string;
  headerMap?: Record<string, string>; // Maps data keys to display headers
  excludeKeys?: string[]; // Keys to exclude from export
}

export const exportToExcel = <T extends Record<string, any>>({
  data,
  fileName = 'export.xlsx',
  headerMap = {},
  excludeKeys = []
}: ExportToExcelOptions<T>) => {
  try {
    if (!data || data.length === 0) {
      console.warn('No data to export');
      return;
    }

    // Filter and format the data
    const filteredData = data.map(item => {
      const filteredItem: Record<string, any> = {};
      
      Object.keys(item).forEach(key => {
        // Skip excluded keys
        if (excludeKeys.includes(key)) return;
        
        // Use mapped header if available, otherwise use the key
        const header = headerMap[key] || key;
        filteredItem[header] = item[key];
      });
      
      return filteredItem;
    });

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    
    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    
    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, `${fileName.replace(/\.xlsx$/i, '')}.xlsx`);
  } catch (error) {
    console.error('Error exporting to Excel:', error);
    throw error;
  }
};
